import { Module } from 'vuex'
import { RootState, CommunitiesState } from './state_models'
export const communities: Module<CommunitiesState, RootState> = {
    namespaced: true,
    state: { locationData: {}, usersData: {} },
    getters: {
        getLocationData: (state: CommunitiesState) => {
			return state.locationData
        },
        getUsersData: (state: CommunitiesState) => {
            return state.usersData
        }
    },
    mutations: {
        setLocationData(state, value) {
            state.locationData = value
        },
        setUsersData(state, value) {
            state.usersData = value
        }
    },
    actions: {}
}